import React from 'react'
import { useTranslation } from 'react-i18next'

export default function CommentCaMarche(){
  const { t } = useTranslation()
  const steps = t('how.steps', { returnObjects: true })
  return (
    <section className="section section-alt">
      <div className="container mx-auto px-4">
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: t('how.title') }} />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map(([t,d],i)=>(
            <div key={i} className="card relative">
              <span className="absolute -top-3 -left-3 w-8 h-8 rounded-lg bg-brown text-white grid place-items-center font-extrabold">{i+1}</span>
              <h4 className="font-bold">{t}</h4>
              <p className="text-muted">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
